module.exports = __webpack_public_path__ + "static/media/Showcase_02.2853a3d9.jpg";